function PlatePatternUtils() {
}

const platePatternUtils = new PlatePatternUtils();

export default platePatternUtils;

class LicencePlateFrame {
    static UNKNOWN = "UNKNOWN";
    static BRAZIL_LEGACY = "BRAZIL_LEGACY";
    static MERCOSUL = "MERCOSUL";
}

class LicencePlatePattern {
    constructor(id, name, regex, formatterReplacement, mask, frame, weak) {
        this.id = id;
        this.name = name;
        this.regex = regex;
        this.regexPattern = new RegExp(regex);
        this.formatterReplacement = formatterReplacement;
        this.mask = mask;
        this.frame = frame;
        this.weak = weak;
    }


    static BRAZIL_LEGACY = new LicencePlatePattern(
        1, 'BRAZIL_LEGACY', "^([A-Z]{3})([0-9]{4})$", "$1-$2", "???####", LicencePlateFrame.BRAZIL_LEGACY, false
    );

    static BRAZIL_MERCOSUL = new LicencePlatePattern(
        2, 'BRAZIL_MERCOSUL', "^([A-Z]{3})([0-9][A-J][0-9]{2})$", "$1 $2", "???#?##", LicencePlateFrame.MERCOSUL, false
    );

    static BRAZIL_MERCOSUL_FAKE = new LicencePlatePattern(
        3, 'BRAZIL_MERCOSUL_FAKE', "^([A-Z]{3})([0-9][K-Z][0-9]{2})$", "$1 $2", "???#?##", LicencePlateFrame.MERCOSUL, true
    );

    static BOLIVIA_LEGACY = new LicencePlatePattern(
        4, 'BOLIVIA_LEGACY', "^[0-9]{4}[A-Z]{3}$", "$0", "####???", LicencePlateFrame.UNKNOWN, false
    );

    static ARGENTINA_MERCOSUL = new LicencePlatePattern(
        5, 'ARGENTINA_MERCOSUL', "^([A-Z]{2})([0-9]{3})([A-Z]{2})$", "$1 $2 $3", "??###??", LicencePlateFrame.MERCOSUL, false
    );

    static PARAGUAY_MERCOSUL = new LicencePlatePattern(
        6, 'PARAGUAY_MERCOSUL', "^([A-Z]{4})([0-9]{3})$", "$1 $2", "????###", LicencePlateFrame.MERCOSUL, true
    );

    static PARAGUAY_MERCOSUL_MOTORCYCLE = new LicencePlatePattern(
        7, 'PARAGUAY_MERCOSUL_MOTORCYCLE', "^([0-9]{3})([A-Z]{4})$", "$1 $2", "###????", LicencePlateFrame.MERCOSUL, false
    );


    static valuesSortedByPriority = [
        LicencePlatePattern.BRAZIL_LEGACY,
        LicencePlatePattern.BRAZIL_MERCOSUL,
        LicencePlatePattern.BRAZIL_MERCOSUL_FAKE,
        LicencePlatePattern.BOLIVIA_LEGACY,
        LicencePlatePattern.ARGENTINA_MERCOSUL,
        LicencePlatePattern.PARAGUAY_MERCOSUL_MOTORCYCLE,
        LicencePlatePattern.PARAGUAY_MERCOSUL,
    ];

    static values() {
        return [
            this.BRAZIL_LEGACY,
            this.BRAZIL_MERCOSUL,
            this.BRAZIL_MERCOSUL_FAKE,
            this.BOLIVIA_LEGACY,
            this.ARGENTINA_MERCOSUL,
            this.PARAGUAY_MERCOSUL,
            this.PARAGUAY_MERCOSUL_MOTORCYCLE,
        ];
    }


    static findByPlate(plate) {
        if(plate == null) return null;

        for (const p of this.valuesSortedByPriority) {

            if (p.regexPattern.test(plate)) {
                return p;
            }
        }
        return null;
    }

    static getMaxPlateLength() {
        return LicencePlatePattern.valuesSortedByPriority
            .reduce((max, p) => Math.max(max, p.mask.replace(/\?/g, 'X').length), 0);
    }

    format(plate) {
        const m = plate.match(this.regexPattern);
        if (!m) return plate;

        return this.formatterReplacement.replace(/\$(\d+)/g, (_, g) => {
            const idx = parseInt(g, 10);
            return m[idx] ?? "";
        });
    }
}

PlatePatternUtils.prototype.cleanRawPlate = function (value){
    if (!value) return '';
    let plate = value.toUpperCase();
    plate = plate.replaceAll(/[^A-Z0-9]/g, '').replaceAll(' ', '');
    return plate;
}
PlatePatternUtils.prototype.existsByPlate= function(value){
    return LicencePlatePattern.findByPlate(value) != null;
}

PlatePatternUtils.prototype.formatPlate = function (value) {
    if (!value) return '';
    let plate = this.cleanRawPlate(value);

    const maxLength = LicencePlatePattern.getMaxPlateLength();


    if (plate.length > maxLength) {
        plate = plate.substring(0, maxLength);
    }

    const pattern = LicencePlatePattern.findByPlate(plate);

    if(pattern === null) return plate;

    return pattern.format(plate);
}

PlatePatternUtils.prototype.formatted = function (plate) {
    if (!plate) return;

    const pattern = LicencePlatePattern.findByPlate(plate);

    if (!pattern) return {
        formattedValue: plate,
        rawValue: plate,
        pattern: 'UNKNOWN',
    };

    const formattedPlate = platePatternUtils.formatPlate(plate);
    return {
        formattedValue: formattedPlate,
        rawValue: plate,
        pattern: pattern.name,
    };

}